import styled from "@emotion/styled";

export const StyledMenuItem = styled.div`
  position: relative;

  display: flex;
  align-items: center;

  white-space: nowrap;
`;

export const StyledMenuBar = styled.div`
  scrollbar-width: none;

  display: flex;
  align-items: center;

  overflow-x: scroll;

  touch-action: pan-x;

  ${StyledMenuItem} + ${StyledMenuItem} {
    margin-inline-start: 16px;
  }
`;
